import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollSummaryExporter  {
    _originalTypeClassName = "zERP.BO.PayrollSummaryExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollSummaryExporter.translate = translateService;
}
this.PayrollSummaryExporterKey = null;
this._key = this.PayrollSummaryExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PayrollSummaryExporterKey:any;
get PayrollSummaryExporterKey(): any {
    return this._PayrollSummaryExporterKey;
  }
set PayrollSummaryExporterKey(value: any) {
    this._PayrollSummaryExporterKey = value;
    this._key = value;
  }

static ExecuteGetBasicSalaryValue(data: any,codes: any): any{let emps = Joove.Common.cast(data?.Calculations?.linq?.selectMany((c) => c?.Employees)?.toArray(), "System.Collections.List");
if (codes?.linq?.where()?.firstOrDefault(null) == "0" || CLMS.Framework.String.IsNullOrEmpty(codes?.linq?.where()?.firstOrDefault(null)) || CLMS.Framework.String.IsNullOrEmpty((codes?.linq?.where()?.firstOrDefault(null) ?? '').trim())) {return emps?.linq?.select((e) => e?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Basic && CLMS.Framework.Number.Equal(() => s.Salary.Priority, () => 0))?.toArray()?.linq?.sum((s) => s?.Amount))?.toArray()?.linq?.sum((s) => s);}else {return emps?.linq?.select((e) => e?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Basic && codes?.linq?.contains(s?.Salary?.Code))?.toArray()?.linq?.sum((s) => s?.Amount))?.toArray()?.linq?.sum((s) => s);}
return null;
}
static ExecuteGetEmpContributionValue(data: any,names: any): any{let emps = Joove.Common.cast(data?.Calculations?.linq?.selectMany((c) => c?.Employees)?.toArray(), "System.Collections.List");
return emps?.linq?.select((e) => e?.Contributions?.linq?.where((c) => names?.linq?.contains(c?.Rule?.Code))?.toArray()?.linq?.sum((s) => s?.EmployeeContribution))?.toArray()?.linq?.sum((s) => s);
}
static ExecuteGetEmpDeductionValue(data: any,codes: any): any{let emps = Joove.Common.cast(data?.Calculations?.linq?.selectMany((c) => c?.Employees)?.toArray(), "System.Collections.List");
return emps?.linq?.select((e) => e?.Deductions?.linq?.where((c) => codes?.linq?.contains(c?.Rule?.Code))?.toArray()?.linq?.sum((s) => s?.EmployeeAmount))?.toArray()?.linq?.sum((s) => s);
}
static ExecuteGetEmployerContributionValue(data: any,names: any): any{let emps = Joove.Common.cast(data?.Calculations?.linq?.selectMany((c) => c?.Employees)?.toArray(), "System.Collections.List");
return emps?.linq?.select((e) => e?.Contributions?.linq?.where((c) => names?.linq?.contains(c?.Rule?.Code))?.toArray()?.linq?.sum((s) => s?.EmployerContribution))?.toArray()?.linq?.sum((s) => s);
}
static ExecuteGetMainSalaryValue(data: any,codes: any): any{let emps = Joove.Common.cast(data?.Calculations?.linq?.selectMany((c) => c?.Employees)?.toArray(), "System.Collections.List");
return emps?.linq?.select((e) => e?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Main && codes?.linq?.contains(s?.Salary?.Code))?.toArray()?.linq?.sum((s) => s?.Amount))?.toArray()?.linq?.sum((s) => s);
}
static ExecuteGetOtherSalaryValue(data: any,codes: any): any{let emps = Joove.Common.cast(data?.Calculations?.linq?.selectMany((c) => c?.Employees)?.toArray(), "System.Collections.List");
return emps?.linq?.select((e) => e?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Other && codes?.linq?.contains(s?.Salary?.Code))?.toArray()?.linq?.sum((s) => s?.Amount))?.toArray()?.linq?.sum((s) => s);
}
static GetCollectionVariables(payroll: any): any{let vars = new window['Map']();
let empty = [];
return vars;
}
static GetFunctions(): any{let functions = [];
functions?.add(Domain.ExcelExporterFunction.Fill("GET_BASIC_SALARY", "Άθροισμα Βασικών αποδοχών", ["Κωδικός αποδοχής"], ["string"], ["Δυνατότητα Πολλαπλών Ορισμάτων"]));
functions?.add(Domain.ExcelExporterFunction.Fill("GET_MAIN_SALARY", "Άθροισμα Κύριων αποδοχών", ["Κωδικός αποδοχής"], ["string"], ["Δυνατότητα Πολλαπλών Ορισμάτων"]));
functions?.add(Domain.ExcelExporterFunction.Fill("GET_OTHER_SALARY", "Άθροισμα Άλλων αποδοχών", ["Κωδικός αποδοχής"], ["string"], ["Δυνατότητα Πολλαπλών Ορισμάτων"]));
functions?.add(Domain.ExcelExporterFunction.Fill("GET_CONTRIBUTIONS", "Άθροισμα Εισφορών Εργαζόμενου", ["Κωδικός εισφοράς"], ["string"], ["Δυνατότητα Πολλαπλών Ορισμάτων"]));
functions?.add(Domain.ExcelExporterFunction.Fill("GET_EMPLOYER_CONTRIBUTIONS", "Άθροισμα Εργοδοτικων Εισφορών", ["Κωδικός εισφοράς"], ["string"], ["Δυνατότητα Πολλαπλών Ορισμάτων"]));
functions?.add(Domain.ExcelExporterFunction.Fill("GET_DEDUCTIONS", "Άθροισμα Κρατήσεων", ["Κωδικός Κράτησης"], ["string"], ["Δυνατότητα Πολλαπλών Ορισμάτων"]));
return functions;
}
static ResolveFunctionInvocation(funcInvocation: any,context: any): any{let data = Joove.Common.cast(context, "Domain.Payroll");
switch (funcInvocation?.Name) {case "GET_BASIC_SALARY":
{
let basicsalary_codes = [];basicsalary_codes?.addRange(funcInvocation?.Arguments?.linq?.select((a) => a?.Value)?.toArray());return Domain.PayrollSummaryExporter.ExecuteGetBasicSalaryValue(data, basicsalary_codes);}
case "GET_MAIN_SALARY":
{
let mainsalary_codes = [];mainsalary_codes?.addRange(funcInvocation?.Arguments?.linq?.select((a) => a?.Value)?.toArray());return Domain.PayrollSummaryExporter.ExecuteGetMainSalaryValue(data, mainsalary_codes);}
case "GET_OTHER_SALARY":
{
let othersalary_codes = [];othersalary_codes?.addRange(funcInvocation?.Arguments?.linq?.select((a) => a?.Value)?.toArray());return Domain.PayrollSummaryExporter.ExecuteGetOtherSalaryValue(data, othersalary_codes);}
case "GET_CONTRIBUTIONS":
{
let employeecontributions_names = [];employeecontributions_names?.addRange(funcInvocation?.Arguments?.linq?.select((a) => a?.Value)?.toArray());return Domain.PayrollSummaryExporter.ExecuteGetEmpContributionValue(data, employeecontributions_names);}
case "GET_EMPLOYER_CONTRIBUTIONS":
{
let employercontributions_codes = [];employercontributions_codes?.addRange(funcInvocation?.Arguments?.linq?.select((a) => a?.Value)?.toArray());return Domain.PayrollSummaryExporter.ExecuteGetEmployerContributionValue(data, employercontributions_codes);}
case "GET_DEDUCTIONS":
{
let deductions_codes = [];deductions_codes?.addRange(funcInvocation?.Arguments?.linq?.select((a) => a?.Value)?.toArray());return Domain.PayrollSummaryExporter.ExecuteGetEmpDeductionValue(data, deductions_codes);}
}
console.error("Unresolved function name: " + funcInvocation?.Name);
return funcInvocation?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollSummaryExporterKey == null || $this.PayrollSummaryExporterKey == 0;
            }


}